import AuthService from '@broadleaf/admin-components/dist/authentication/services/AuthService';

export const getSecureAssetUrl = async (assetUrl: string): Promise<string> => {
  const token = (await AuthService.getToken('ASSET')) as {
    access_token: string;
    expiry?: number;
  };
  if (assetUrl && token) {
    // add the access token to the src url, using & or ? as appropriate
    const separator = assetUrl.includes('?') ? '&' : '?';
    assetUrl = `${assetUrl}${separator}access_token=${token.access_token}`;
  }
  return assetUrl;
};
